const vn = {
  "layout": {
    "overview":"Tổng quan",
    "profile":"Hồ sơ",
    "project":"Dự án",
    "dashboard": "Bản điều khiển",
    "security":"Bảo mật",
    "accountSetting":"Cài đặt tài khoản",
    "home": {
      "home": "Trang chủ",
      "banner": "Tiêu đề",
      "solution":"Giải pháp",
      "contact":"Liên hệ",
    },
    "banner": {
      "subSection1": "Phần con 1",
      "subSection2": "Phần con 2"
    },
    "success": "Thành công",
    "updateSuccess": "Dữ liệu được cập nhật thành công!",
    
  },
  "home": {

  },
  "login":{
    "success": "Thành công",
    "messSuccess": "Đăng nhập thành công!",
    "failure": "Thất bại",
    "mesFailure": "Tài khoản hoặc mật khẩu không chính xác!",
  },
  "sizeIdeal":"Kích thước lý tưởng",
  "edit": "Chỉnh sửa",
  "update":"Cập nhật",
  "continue":"Tiếp tục",
  "agree":"Đồng ý",
  "cancel":"Hủy bỏ",
  "titleFile":"Nhấp hoặc kéo tệp vào khu vực này để tải lên",
  "descFile":"Hỗ trợ tải lên một lần. Nghiêm cấm tải lên các tập tin bị cấm khác.",
  "basicInformation": "Thông tin cơ bản",
  "tag": "Nhãn",
  "title": "Tiêu đề",
  "describtion": "Mô tả",
  "imageInfo": "Thông tin ảnh",
  "messUpdate":"Dữ liệu được cập nhật thành công!",
   
  "exitModal":"Thoát không lưu?",
  "descExitModal":"Bạn có muốn thoát và không lưu dữ liệu hay không?",
  "tagInfo": {
    "message": "Vui lòng nhập nhãn!",
    "placeholder": "Nội dung nhãn"
  },
  "titleInfo": {
    "message": "Vui lòng nhập tiêu đề!",
    "placeholder": "Nội dung tiêu đề"
  },
  "descInfo": {
    "message": "Vui lòng nhập mô tả!",
    "placeholder": "Nội dung mô tả"
  },
  

};

export default vn;
